import React from "react";
import Release from "./Release";
import { Router, Route, Switch } from "react-router-dom";
import { clearCache } from "clear-cache";

import { GlobalStyle } from "./style";
import "mapbox-gl/dist/mapbox-gl.css";

import history from "./utils/history";
import ToTop from "./common/scroll";
import Modal from "./common/modal/modal";
import ToastContainer from "./common/toastNotification";
import MainPageRoutes from "./MainPage";
import ErrorBoundary from "./pages/errorPage/errorBoundary";
import OurSuspense from "common/suspense";

const Login = React.lazy(() => import("./pages/loginPage/login"));
const InviteLogin = React.lazy(() => import("./pages/loginPage/inviteLogin"));
const SignUp = React.lazy(() => import("./pages/loginPage/signUp"));
const FileDownload = React.lazy(() => import("./pages/fileDownload"));
const Error401NoAcc = React.lazy(() => import("./pages/errorPage/401NoAcc"));
const Error403AccessDenied = React.lazy(() => import("./pages/errorPage/403"));

class App extends React.Component {
  componentDidMount() {
    const NODE_ENV = process.env.NODE_ENV;
    console.log(`Running under ${NODE_ENV} environment...`);
    if (NODE_ENV !== "development") {
      let version = localStorage.getItem("version");
      if (version !== Release?.version) {
        localStorage.clear();
        localStorage.setItem("version", Release?.version);

        setTimeout(() => {
          console.log(
            "Production Version has been changed, reloading in 3 seconds...",
          );
          clearCache();
        }, 3000);
      }
      console.log(`version: ${version}`);
      console.log(`package version: ${Release?.version}`);
    }
  }

  render() {
    return (
      <Router history={history}>
        <GlobalStyle />
        <ErrorBoundary>
          <OurSuspense>
            <Switch>
              <Route path="/login" exact component={Login} />
              <Route path="/invite_login" exact component={InviteLogin} />
              <Route path="/sign_up" exact component={SignUp} />
              <Route
                path="/error_401_no_accounts"
                exact
                component={Error401NoAcc}
              />
              <Route
                path="/access-denied"
                exact
                component={Error403AccessDenied}
              />
              <Route
                path="/file/:token"
                exact
                render={(props) => <FileDownload {...props} />}
              />
              <MainPageRoutes />
            </Switch>
          </OurSuspense>
        </ErrorBoundary>
        <ToastContainer />
        <Modal />
        <ToTop />
      </Router>
    );
  }
}

export default App;
